module.exports = __webpack_public_path__ + "media/images/contest-vote-title@3x-3a3b40c8601e95364f063e70a7412f4d.png";